/**
 * @author Ilya Aderiho.
 */
var bfBind = { data: '=' };
var DetailTableDuplCheckController = (function () {
    function DetailTableDuplCheckController(topic, settings, socket, $injector, env, $timeout, $stateParams, $scope) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.comp = 'dc';
        this.updateArray = ['dc'];
        this.lock = true;
        this.requiredCountrySearch = true;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.showBPOI = this.topic.useBPOI();
        this.tableName = 'Duplicate Check';
        this.dc = {
            accountName: '',
            alterBrandFam: [],
            countrySelected: '',
            ds: 'MYSA_DUP',
            isDRPGSearch: false,
            opp: ''
        };
        this.visible = false;
        this.expand = false;
        this.stopSubmit = false;
        this.filterDisplay = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.showBPOI = _this.topic.checksData.uiVersion >= 4 ? false : _this.topic.useBPOI();
            _this.dataSources = _this.showBPOI ? ['MYSA_DUP', 'SC_DUP'] : ['MYSA_DUP'];
        });
    }
    ;
    DetailTableDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    // For EU/NA vs AP different options to display
    DetailTableDuplCheckController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        this.showBPOI = this.topic.checksData.uiVersion >= 4 ? false : this.topic.useBPOI();
        this.dataSources = this.showBPOI ? ['MYSA_DUP', 'SC_DUP'] : ['MYSA_DUP']; // was this.useBPOI()
        this.usPicked = false;
        if (angular.isDefined(this.topic.country.imt)) {
            if (this.topic.country.imt === 'Japan IOT' || this.topic.country.imt === 'Greater China Group IOT' ||
                this.topic.country.imt === 'Asia Pacific IOT') {
            }
            this.countryDecided = true;
        }
        else {
            this.countryDecided = false;
        }
    };
    DetailTableDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableDuplCheckController.prototype.sendDupliCheck = function (opp) {
        if (!this.countryDecided) {
            this.topic.setCountry();
            if (angular.isUndefined(this.topic.country.imt)) {
                return alert("It was not possible to find a Country Profile for the Account Country - " + this.topic.topic.gpp[0].acctctry + ".\n           Please contact the System Administrators and ask to have it added.");
            }
            this.countryDecided = true;
        }
        this.dc.version = this.topic.checksData.uiVersion;
        this.dc.sviSubmitDate = _.get(this, "topic.checksData.inbound.inboud.incentiveInformation.incentiveDetail.incentiveSubmitDate");
        if (!this.dc.sviSubmitDate) {
            this.dc.sviSubmitDate = _.get(this, "topic.checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveSubmitDate");
        }
        this.dc.bpCEID = _.get(this, "topic.checksData.inbound.inboud.incentiveInformation.incentiveDetail.submittingCeid");
        if (!this.dc.bpCEID) {
            this.dc.bpCEID = _.get(this, "topic.checksData.inbound.inbound.incentiveInformation.incentiveDetail.submittingCeid");
        }
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            this.dc.opp = opp;
            this.dc.gpp = this.topic.topic.gpp || this.topic.topic.gpp_lastload;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topic.topicBrowserID,
                    data: this.dc,
                    function: 'startManualDuplicateCheck',
                    partial: true,
                    script: '/detail/eligibility/duplicate/index',
                    token: this.env.user.token
                }
            });
        }
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableDuplCheckController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.dc', value);
        this.expand = value;
    };
    DetailTableDuplCheckController.prototype.updateBant = function () {
        this.topic.setTempFromTopicPart(this.comp);
        var upData = {
            id: this.topic.topic._id,
            data: {
                'dc.0.bant': {
                    add: true,
                    data: this.topic.temp.dc[0].bant
                }
            },
            type: ['dc', 'complcl3']
        };
        this.topic.updateServerTopic('couchUpdate', upData, false);
    };
    DetailTableDuplCheckController.prototype.reload = function () {
        console.info('$detail.table.duplcheck (reload) => reloading');
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckController.prototype.pushAlterBfItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.alterBrandFam, function (iter) {
            if (iter === _this.alterToBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.alterBrandFam.push(this.alterToBeInserted);
        }
        this.alterToBeInserted = '';
    };
    DetailTableDuplCheckController.prototype.clearAlterBFList = function () {
        this.dc.alterBrandFam = [];
    };
    DetailTableDuplCheckController.prototype.hasCheckRun = function (type) {
        if (this.topic.topic.dc && this.topic.topic.dc.results) {
            for (var _i = 0, _a = this.topic.topic.dc.results; _i < _a.length; _i++) {
                var oneRes = _a[_i];
                if (oneRes.ds === type && !oneRes.error) {
                    return true;
                }
            }
        }
        return false;
    };
    DetailTableDuplCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var data = {
                id: this.topic.topic._id,
                data: (_a = {},
                    _a['dc'] = {
                        add: true,
                        data: this.topic.temp.dc
                    },
                    _a['complcl3'] = {
                        add: true,
                        data: this.topic.temp.complcl3
                    },
                    _a
                ),
                type: ['dc', 'complcl3']
            };
            this.topic.updateServerTopic('couchUpdate', data, true);
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        var _a;
    };
    DetailTableDuplCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$stateParams', '$scope'];
    return DetailTableDuplCheckController;
}());
var DetailTableDuplCheckComponent = (function () {
    function DetailTableDuplCheckComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.bindings = bfBind;
        this.controllerAs = 'vm';
        this.controller = DetailTableDuplCheckController;
    }
    return DetailTableDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheck', new DetailTableDuplCheckComponent());

//# sourceMappingURL=detail.table.duplcheck.component.js.map
